<template>
  <Alert
      :message="message"
      v-if="message"
      :outlined="true"
      :inline-actions="false"
      :action-props="{

      }"
  />
</template>

<script lang="ts" setup>

import {DeliveryCalculate, MenuItem, Message} from "@/gql/gen";
import Alert from "@/components/Ui/Alert/Alert.vue";
import {computed, toRefs} from "vue";
import {formatTime} from "@/core/util/date/formatTime";
import {useDeliveryStore} from "@/modules/shop/store/delivery";

const emit = defineEmits<{
  selected: [DeliveryCalculate],
}>()

const deliveryStore = useDeliveryStore()

const {setDeliveryCalculateResult} = deliveryStore

const props = withDefaults(defineProps<{
  calc: DeliveryCalculate
}>(), {})

const {calc} = toRefs(props)

const message = computed(() => {
  if (!calc.value)
    return;

  const res = {} as Message
  switch (calc.value.RES_STATUS) {
    case 'success':
      res.type = 'success'
      res.message = 'Время свободно'
      break
    case 'time_busy':
      res.type = 'warning'
      res.message = 'Время занято, выбрать ближайшее:'

      if (calc.value?.RES_TIME) {
        res.actions = [
          {
            label: formatTime({value: calc.value.RES_TIME}).datetimeFormatted,
            onClick: () => {
              calc.value.RES_STATUS = 'success'
              setDeliveryCalculateResult(calc.value)
              emit('selected', calc.value)
            }
          }
        ] as MenuItem[]
      }

      break
    case 'service_unavailable':
      res.type = 'error'
      res.message = 'Не удалось проверить время, попробуйте снова'
      break
    case 'address_not_found':
      res.type = 'error'
      res.message = 'Адрес не найден'
      break
  }
  return res
})

</script>

<style lang="scss" scoped>


</style>
